var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b-faq",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M15.05 27q4.9 0 8.45-3.5Q27 20 27 15q0-4.95-3.5-8.5Q19.95 3 15.05 3 10 3 6.5 6.5 3 10.05 3 15q0 5 3.5 8.5t8.55 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-faq",
    fill: "none",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M15.05 17.8v-2.4q1.45 0 2.5-1.05t1.05-2.55q0-1.5-1.05-2.55-1.05-1.05-2.5-1.05-1.5 0-2.6 1.05-1.05 1.05-1.05 2.55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a-faq"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27 15q0-4.95-3.5-8.5Q19.95 3 15.05 3 10 3 6.5 6.5 3 10.05 3 15q0 5 3.5 8.5t8.55 3.5q4.9 0 8.45-3.5Q27 20 27 15M12.45 9.25Q11.4 10.3 11.4 11.8q0-1.5 1.05-2.55 1.1-1.05 2.6-1.05 1.45 0 2.5 1.05t1.05 2.55q0 1.5-1.05 2.55-1.05 1.05-2.5 1.05v2.4-2.4q1.45 0 2.5-1.05t1.05-2.55q0-1.5-1.05-2.55-1.05-1.05-2.5-1.05-1.5 0-2.6 1.05m2.6 13.9q-.65 0-1.1-.4-.5-.45-.5-1.1 0-.65.5-1.05.45-.45 1.1-.45.6 0 1 .45.45.45.45 1.05 0 .65-.45 1.1-.4.4-1 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M13.95 22.75q.45.4 1.1.4.6 0 1-.4.45-.45.45-1.1 0-.6-.45-1.05-.4-.45-1-.45-.65 0-1.1.45-.5.4-.5 1.05t.5 1.1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-faq"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-faq"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c-faq"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon-faq.40bbc82450a0e13b7b92f5a8f51068c4.svg";
export { ForwardRef as ReactComponent };